(function () {
  var ROOT = document.getElementById('rr-ranch-helper');
  if (!ROOT) return;

  var HANDLES = [
    // Ariat excluded until Ariat II launches (products stay on site; not in helper pool)
    'bull-xl-manual', 'bull-xl-hydraulic', 'ranger-xl', 'ranger-xl-hydraulic',
    'big-red-xl', 'cattl-ek-xl',
    'grazer-portable-corral', 'rustler-portable-corral',
    'stationary-sweep-tub', 'portable-bud-tub', 'stationary-adjustable-alley',
    'stationary-loading-ramp', 'portable-cattle-loading-ramp'
  ];

  var META = {
    'bull-xl-manual': { family: 'chute', power: 'manual', mobility: 'portable-friendly', xlCage: true, weight: 'light', price: 5800, label: 'Bull XL Manual' },
    'bull-xl-hydraulic': { family: 'chute', power: 'hydraulic', mobility: 'portable-friendly', xlCage: true, weight: 'mid', price: 8750, label: 'Bull XL Hydraulic' },
    'ranger-xl': { family: 'chute', power: 'manual', mobility: 'portable-friendly', xlCage: true, weight: 'mid', price: 7300, label: 'Ranger XL Manual' },
    'ranger-xl-hydraulic': { family: 'chute', power: 'hydraulic', mobility: 'portable-friendly', xlCage: true, weight: 'heavy', price: 12200, label: 'Ranger XL Hydraulic' },
    'big-red-xl': { family: 'chute', power: 'hydraulic', mobility: 'fixed', xlCage: true, weight: 'heavy', price: 17300, label: 'Big Red XL' },
    'cattl-ek-xl': { family: 'chute', power: 'hydraulic', mobility: 'fixed', xlCage: true, weight: 'heavy', price: 17300, label: 'CATTL-EK HD' },
    'ariat-xl-manual': { family: 'chute', power: 'manual', mobility: 'portable-friendly', xlCage: true, weight: 'light', price: 4400, label: 'Ariat XL Manual' },
    'ariat-xl-hydraulic': { family: 'chute', power: 'hydraulic', mobility: 'portable-friendly', xlCage: true, weight: 'light', price: 5950, label: 'Ariat XL Hydraulic' },
    'grazer-portable-corral': { family: 'pens', power: null, mobility: 'portable', xlCage: false, weight: 'mid', price: 19900, label: 'Grazer Portable Corral' },
    'rustler-portable-corral': { family: 'pens', power: null, mobility: 'portable', xlCage: false, weight: 'heavy', price: 29900, label: 'Rustler Portable Corral' },
    'stationary-sweep-tub': { family: 'flow', power: null, mobility: 'fixed', xlCage: false, weight: 'mid', price: 4000, label: 'Stationary Sweep Tub' },
    'portable-bud-tub': { family: 'flow', power: null, mobility: 'portable', xlCage: false, weight: 'mid', price: 4600, label: 'Portable Bud Tub' },
    'stationary-adjustable-alley': { family: 'flow', power: null, mobility: 'fixed', xlCage: false, weight: 'light', price: 2200, label: 'Stationary Adjustable Alley' },
    'stationary-loading-ramp': { family: 'loading', power: null, mobility: 'fixed', xlCage: false, weight: 'mid', price: 4900, label: '19 ft Stationary Loading Ramp' },
    'portable-cattle-loading-ramp': { family: 'loading', power: null, mobility: 'portable', xlCage: false, weight: 'light', price: 3900, label: 'Adjustable Portable Loading Ramp' }
  };

  var answers = {};
  var stepIndex = 0;
  var questions = Array.prototype.slice.call(ROOT.querySelectorAll('.rr-rh-q'));
  var catalog = {}; // handle -> {title, price, image, url}

  var intro = document.getElementById('rr-rh-intro');
  var quiz = document.getElementById('rr-rh-quiz');
  var results = document.getElementById('rr-rh-results');
  var grid = document.getElementById('rr-rh-grid');
  var stepLabel = document.getElementById('rr-rh-step-label');
  var progressFill = document.getElementById('rr-rh-progress-fill');
  var btnNext = document.getElementById('rr-rh-next');
  var btnBack = document.getElementById('rr-rh-back');

  function money(n) {
    var x = parseFloat(n, 10);
    if (!isFinite(x) || x <= 0) return null;
    return '$' + Math.round(x).toLocaleString('en-US');
  }

  function loadCatalog() {
    return fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        (data.products || []).forEach(function (p) {
          if (HANDLES.indexOf(p.handle) === -1) return;
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          var price = (p.variants && p.variants[0] && p.variants[0].price) || null;
          catalog[p.handle] = {
            title: p.title,
            price: price,
            image: img,
            url: '/products/' + p.handle
          };
        });
      })
      .catch(function () { /* offline / block — still score with META labels */ });
  }

  function showStep(i) {
    stepIndex = i;
    questions.forEach(function (q, idx) {
      q.classList.toggle('is-active', idx === i);
    });
    var total = questions.length; // 8 ranch questions; info is step 9
    stepLabel.textContent = 'Question ' + (i + 1) + ' of 9';
    progressFill.style.width = (((i + 1) / 9) * 100) + '%';
    btnBack.disabled = false;
    btnBack.style.visibility = i === 0 ? 'hidden' : 'visible';
    var key = questions[i].getAttribute('data-key');
    btnNext.disabled = !answers[key];
    btnNext.textContent = i === total - 1 ? 'Next' : 'Next';
  }

  var infoStep = document.getElementById('rr-rh-info');

  function showInfoStep() {
    quiz.classList.add('rr-rh-hidden');
    infoStep.classList.add('is-active');
    results.classList.remove('is-active');
    infoStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hideInfoStep() {
    infoStep.classList.remove('is-active');
  }

  function goToResults(opts) {
    opts = opts || {};
    hideInfoStep();
    quiz.classList.add('rr-rh-hidden');
    results.classList.add('is-active');
    renderResults();
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (opts.sendLead) {
      // mailto opens the user’s email app; page stays on results
      var href = buildMailto({ callback: true });
      window.setTimeout(function () {
        var a = document.createElement('a');
        a.href = href;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, 350);
    }
  }

  function contactFilled() {
    var phone = (document.getElementById('rr-rh-phone').value || '').trim();
    var email = (document.getElementById('rr-rh-email').value || '').trim();
    return !!(phone || email);
  }

  function handleInfoContinue() {
    var want = document.getElementById('rr-rh-want-callback').checked;
    var prompt = document.getElementById('rr-rh-info-prompt');
    prompt.classList.remove('is-visible');
    if (want && !contactFilled()) {
      prompt.classList.add('is-visible');
      return;
    }
    goToResults({ sendLead: want && contactFilled() });
  }

  function selectOption(btn) {
    var card = btn.closest('.rr-rh-q');
    var key = card.getAttribute('data-key');
    card.querySelectorAll('.rr-rh-opt').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    answers[key] = btn.getAttribute('data-value');
    btnNext.disabled = false;
  }

  function scoreProducts() {
    var scores = {};
    HANDLES.forEach(function (h) { scores[h] = 0; });
    var need = answers.need || 'unsure';
    var head = answers.headcount || 'unsure';
    var mob = answers.mobility || 'unsure';
    var alone = answers.alone || 'unsure';
    var flow = answers.flow || 'unsure';
    var budget = answers.budget || 'unsure';
    var power = answers.power || 'unsure';
    var setup = answers.setup || 'unsure';

    var CHUTE_HANDLES = [
      'bull-xl-manual', 'bull-xl-hydraulic', 'ranger-xl', 'ranger-xl-hydraulic',
      'big-red-xl', 'cattl-ek-xl'
    ];
    var FLOW_HANDLES = ['stationary-adjustable-alley', 'portable-bud-tub', 'stationary-sweep-tub'];
    var CORRAL_HANDLES = ['grazer-portable-corral', 'rustler-portable-corral'];
    var chuteOnly = (setup === 'chute_only');
    var wantFlowGear = !chuteOnly && (flow === 'yes' || flow === 'unsure' || setup === 'chute_plus_flow' || setup === 'full');

    function priceOf(h) {
      if (catalog[h] && catalog[h].price) {
        var p = parseFloat(catalog[h].price, 10);
        if (isFinite(p)) return p;
      }
      return META[h].price || 0;
    }

    function modelKey(h) {
      if (h.indexOf('bull') === 0) return 'bull';
      if (h.indexOf('ranger') === 0) return 'ranger';
      if (h.indexOf('big-red') === 0) return 'big-red';
      if (h.indexOf('cattl') === 0) return 'cattl-ek';
      if (h.indexOf('grazer') === 0) return 'grazer';
      if (h.indexOf('rustler') === 0) return 'rustler';
      if (h.indexOf('bud') !== -1) return 'bud';
      if (h.indexOf('sweep') !== -1) return 'sweep';
      if (h.indexOf('alley') !== -1) return 'alley';
      if (h.indexOf('ramp') !== -1) return 'ramp';
      return h;
    }

    /** Budget band targets for Good / Better / Best (consumer habit). */
    function bandTargets() {
      // [goodTarget, betterTarget, bestTarget, bandLo, bandHi, stretchHi]
      if (budget === 'under6k') return { good: 4500, better: 5500, best: 8000, lo: 0, hi: 6000, stretch: 10000 };
      if (budget === '6to10') return { good: 6500, better: 8500, best: 12000, lo: 6000, hi: 10000, stretch: 18000 };
      if (budget === '10to18') return { good: 11000, better: 15000, best: 18000, lo: 10000, hi: 18000, stretch: 30000 };
      if (budget === '18plus') return { good: 18000, better: 22000, best: 28000, lo: 18000, hi: 999999, stretch: 999999 };
      // unsure / exploring → mid mix ~$6–18k
      return { good: 7000, better: 12000, best: 17300, lo: 6000, hi: 18000, stretch: 30000 };
    }

    function budgetFit(price) {
      var t = bandTargets();
      if (budget === 'unsure' || budget === 'exploring') {
        if (price >= t.lo && price <= t.hi) return 4;
        if (price < t.lo) return 2;
        return 1;
      }
      if (price >= t.lo && price <= t.hi) return 8;
      if (price > t.hi && price <= t.stretch) return 3; // stretch OK for Best
      if (price < t.lo && price >= t.lo * 0.7) return 2;
      if (budget === 'under6k' && price < 6000) return 8;
      if (budget === '18plus' && price >= 15000) return 6;
      return -2;
    }

    // --- Affinity scoring (kind rules + ranch answers) ---
    HANDLES.forEach(function (h) {
      var m = META[h];
      var s = 0;
      var livePrice = priceOf(h);

      if (h === 'ariat-xl-manual' || h === 'ariat-xl-hydraulic') {
        scores[h] = -9999;
        return;
      }
      if (chuteOnly && m.family !== 'chute') {
        scores[h] = -9999;
        return;
      }

      if (m.family === 'chute' && m.xlCage) s += 3;

      if (need === 'chute' && m.family === 'chute') s += 12;
      if (need === 'leadup' && FLOW_HANDLES.indexOf(h) !== -1) s += 14;
      if (need === 'leadup' && CORRAL_HANDLES.indexOf(h) !== -1) s -= 4; // not primarily corrals
      if (need === 'corral' && CORRAL_HANDLES.indexOf(h) !== -1) s += 16;
      if (need === 'corral' && h === 'portable-bud-tub') s += 6; // portable crowding helper
      if (need === 'corral' && META[h].family === 'chute') s -= 2;
      if (need === 'corral' && (h === 'stationary-sweep-tub' || h === 'stationary-adjustable-alley')) s -= 1;
      if (need === 'loading' && m.family === 'loading') s += 14;
      if (need === 'unsure') {
        if (m.family === 'chute') s += 6;
        if (m.family === 'flow') s += 4;
        if (m.family === 'pens') s += 4;
        if (m.family === 'loading') s += 3;
      }
      if (need === 'leadup' && mob === 'fixed' && (h === 'stationary-sweep-tub' || h === 'stationary-adjustable-alley')) s += 6;
      if (need === 'leadup' && mob === 'portable' && h === 'portable-bud-tub') s += 6;
      if (need === 'corral' && mob === 'portable' && CORRAL_HANDLES.indexOf(h) !== -1) s += 4;
      // Headcount on corrals: Grazer smaller, Rustler larger
      if (CORRAL_HANDLES.indexOf(h) !== -1) {
        if (head === 'under50' && h === 'grazer-portable-corral') s += 8;
        if (head === 'under50' && h === 'rustler-portable-corral') s += 2;
        if (head === 'mid' && h === 'rustler-portable-corral') s += 7;
        if (head === 'mid' && h === 'grazer-portable-corral') s += 4;
        if (head === 'large' && h === 'rustler-portable-corral') s += 9;
        if (head === 'large' && h === 'grazer-portable-corral') s += 2;
        if (head === 'unsure' && h === 'grazer-portable-corral') s += 3;
      }
      if (mob === 'portable') {
        if (m.mobility === 'portable') s += 7;
        if (m.mobility === 'portable-friendly') s += 4;
        if (m.mobility === 'fixed') s -= 3;
      }
      if (mob === 'fixed') {
        if (m.mobility === 'fixed') s += 6;
        if (m.family === 'chute' && (h === 'big-red-xl' || h === 'cattl-ek-xl')) s += 3;
        if (m.mobility === 'portable' && m.family !== 'pens' && m.family !== 'flow') s -= 2;
      }
      if (m.family === 'chute') {
        if (power === 'manual' && m.power === 'manual') s += 8;
        if (power === 'hydraulic' && m.power === 'hydraulic') s += 8;
        if (power === 'manual' && m.power === 'hydraulic') s -= 3;
        if (power === 'hydraulic' && m.power === 'manual') s -= 2;
        if (power === 'unsure' && m.power === 'manual') s += 2;
      }
      if (alone === 'yes') {
        if (m.weight === 'light') s += 3;
        if (m.power === 'manual') s += 2;
        if (m.weight === 'heavy' && m.family === 'chute') s -= 2;
      }
      if (head === 'large' || power === 'hydraulic') {
        if (h === 'big-red-xl' || h === 'cattl-ek-xl') s += 4;
        if (h === 'bull-xl-hydraulic' || h === 'ranger-xl-hydraulic') s += 3;
      }
      if (head === 'under50' && alone === 'yes' && (h === 'bull-xl-manual' || h === 'ranger-xl')) s += 3;

      if (wantFlowGear && (flow === 'yes' || flow === 'unsure' || setup === 'chute_plus_flow' || setup === 'full')) {
        if (FLOW_HANDLES.indexOf(h) !== -1) s += 8;
        if (need === 'chute' && FLOW_HANDLES.indexOf(h) !== -1) s += 4;
      }
      if (!chuteOnly && flow === 'no' && FLOW_HANDLES.indexOf(h) !== -1) s -= 2;

      if (setup === 'chute_only' && m.family === 'chute') s += 10;
      if (setup === 'chute_plus_flow') {
        if (m.family === 'chute') s += 5;
        if (FLOW_HANDLES.indexOf(h) !== -1) s += 8;
        if (CORRAL_HANDLES.indexOf(h) !== -1) s -= 2;
        if (m.family === 'loading') s -= 3;
      }
      if (setup === 'full') {
        if (FLOW_HANDLES.indexOf(h) !== -1) s += 14;
        if (CORRAL_HANDLES.indexOf(h) !== -1) s += 12;
        if (m.family === 'chute') s += 5;
        if (m.family === 'loading') s -= 4;
      }
      if (setup === 'unsure') {
        if (need === 'chute' && m.family === 'chute') s += 4;
        if (wantFlowGear && FLOW_HANDLES.indexOf(h) !== -1) s += 3;
      }

      s += budgetFit(livePrice);
      scores[h] = s;
    });

    function eligible(filterFn) {
      return HANDLES.filter(function (h) {
        if (scores[h] <= -9999) return false;
        return filterFn ? filterFn(h) : true;
      });
    }

    /**
     * Pick Good / Better / Best from candidates by price targets.
     * Diversify model lines. Prefer affinity score as tie-breaker.
     */
    function pickGoodBetterBest(candidates, forceCount) {
      var t = bandTargets();
      var pool = candidates.slice().filter(function (h) { return scores[h] > -9999; });
      if (!pool.length) return [];

      function dist(h, target) { return Math.abs(priceOf(h) - target); }

      function pickNear(target, used, preferInBand, allowStretch) {
        var best = null, bestScore = Infinity;
        pool.forEach(function (h) {
          if (used.indexOf(h) !== -1) return;
          var pr = priceOf(h);
          // Soft prefer in-band for Good; Better allows near; Best allows stretch
          var penalty = 0;
          if (preferInBand === 'good') {
            if (pr > t.hi) penalty += (pr - t.hi) * 0.5 + 2000;
            if (budget === 'under6k' && pr > 6000) penalty += 1500;
          } else if (preferInBand === 'better') {
            if (pr > t.stretch) penalty += 5000;
            if (pr < t.lo * 0.5) penalty += 1000;
          } else if (preferInBand === 'best') {
            if (allowStretch && pr > t.hi && pr <= t.stretch) penalty -= 500; // encourage mild stretch
            if (pr < t.lo) penalty += 2000;
            if (pr > t.stretch) penalty += 4000;
          }
          // diversify models
          var mk = modelKey(h);
          used.forEach(function (u) {
            if (modelKey(u) === mk) penalty += 8000;
          });
          // Power preference: Good/Better should honor manual vs hydraulic when answered
          if (META[h].family === 'chute' && META[h].power) {
            if (power === 'manual' && META[h].power === 'manual') penalty -= 3500;
            if (power === 'manual' && META[h].power === 'hydraulic') penalty += (preferInBand === 'best' ? 800 : 4500);
            if (power === 'hydraulic' && META[h].power === 'hydraulic') penalty -= 3500;
            if (power === 'hydraulic' && META[h].power === 'manual') penalty += (preferInBand === 'best' ? 800 : 4500);
          }
          // affinity: higher scores slightly preferred
          penalty -= (scores[h] || 0) * 15;
          var d = dist(h, target) + penalty;
          if (d < bestScore) { bestScore = d; best = h; }
        });
        return best;
      }

      var good = pickNear(t.good, [], 'good', false);
      var better = pickNear(t.better, good ? [good] : [], 'better', false);
      var best = pickNear(t.best, [good, better].filter(Boolean), 'best', true);

      var out = [good, better, best].filter(Boolean);
      // Fill if short
      pool.sort(function (a, b) {
        return (scores[b] - scores[a]) || (priceOf(a) - priceOf(b));
      });
      pool.forEach(function (h) {
        if (out.length >= (forceCount || 3)) return;
        if (out.indexOf(h) === -1) {
          // still prefer new models
          var mk = modelKey(h);
          if (out.some(function (u) { return modelKey(u) === mk; }) && out.length < (forceCount || 3) - 1) {
            // skip same model if we can fill later
            return;
          }
          out.push(h);
        }
      });
      pool.forEach(function (h) {
        if (out.length >= (forceCount || 3)) return;
        if (out.indexOf(h) === -1) out.push(h);
      });

      // Present Good→Better→Best by ascending price when all same kind (chutes)
      // Keep order good, better, best intentionally (not pure sort) — consumer habit ladder
      return out.slice(0, forceCount || 3);
    }

    function bestByScore(list) {
      var b = null, bs = -99999;
      list.forEach(function (h) {
        if (scores[h] > bs) { bs = scores[h]; b = h; }
      });
      return b;
    }

    var picked = [];
    var tiers = []; // good/better/best labels parallel to picked

    if (chuteOnly) {
      var chutes = eligible(function (h) { return META[h].family === 'chute'; });
      picked = pickGoodBetterBest(chutes, 3);
      tiers = ['good', 'better', 'best'].slice(0, picked.length);
    } else if (setup === 'chute_plus_flow') {
      // Kind rule: 1–2 chutes + 1 flow. Apply G/B among chutes; Best slot = flow (or Best=stretch chute if only one chute slot)
      var chutes2 = eligible(function (h) { return META[h].family === 'chute'; });
      var flows = eligible(function (h) { return FLOW_HANDLES.indexOf(h) !== -1; });
      // Prefer portable bud when portable; sweep/alley when fixed
      flows.sort(function (a, b) {
        var ba = 0, bb = 0;
        if (mob === 'portable' && a === 'portable-bud-tub') ba += 5;
        if (mob === 'portable' && b === 'portable-bud-tub') bb += 5;
        if (mob === 'fixed' && (a === 'stationary-sweep-tub' || a === 'stationary-adjustable-alley')) ba += 5;
        if (mob === 'fixed' && (b === 'stationary-sweep-tub' || b === 'stationary-adjustable-alley')) bb += 5;
        return (scores[b] + bb) - (scores[a] + ba);
      });
      var chutePicks = pickGoodBetterBest(chutes2, 2);
      var flowPick = flows[0] || bestByScore(FLOW_HANDLES);
      picked = chutePicks.slice(0, 2);
      tiers = ['good', 'better'].slice(0, picked.length);
      if (flowPick && picked.indexOf(flowPick) === -1) {
        picked.push(flowPick);
        tiers.push('best');
      }
      if (picked.length < 2) {
        pickGoodBetterBest(chutes2, 3).forEach(function (h) {
          if (picked.indexOf(h) === -1 && picked.length < 3) {
            picked.push(h);
            tiers.push(tiers.length === 0 ? 'good' : (tiers.length === 1 ? 'better' : 'best'));
          }
        });
      }
    } else if (setup === 'full') {
      // Kind: chute + flow + optionally corral. Price ladder across the mix where possible.
      var chutes3 = eligible(function (h) { return META[h].family === 'chute'; });
      var flows3 = eligible(function (h) { return FLOW_HANDLES.indexOf(h) !== -1; });
      var corrals = eligible(function (h) { return CORRAL_HANDLES.indexOf(h) !== -1; });
      var goodChute = pickGoodBetterBest(chutes3, 1)[0] || bestByScore(chutes3);
      // flow pick with mobility bias
      var flowSorted = flows3.slice().sort(function (a, b) {
        var ba = scores[a], bb = scores[b];
        if (mob === 'portable' && a === 'portable-bud-tub') ba += 5;
        if (mob === 'portable' && b === 'portable-bud-tub') bb += 5;
        if (mob === 'fixed' && (a.indexOf('stationary') === 0)) ba += 5;
        if (mob === 'fixed' && (b.indexOf('stationary') === 0)) bb += 5;
        return bb - ba;
      });
      var flowPick2 = flowSorted[0];
      var corralSorted = corrals.slice().sort(function (a, b) {
        var ba = scores[a], bb = scores[b];
        if (head === 'large' && a === 'rustler-portable-corral') ba += 3;
        if (head === 'large' && b === 'rustler-portable-corral') bb += 3;
        if ((head === 'under50' || head === 'mid') && a === 'grazer-portable-corral') ba += 2;
        if ((head === 'under50' || head === 'mid') && b === 'grazer-portable-corral') bb += 2;
        if (mob === 'portable') { ba += 2; bb += 2; }
        return bb - ba;
      });
      var corralPick = corralSorted[0];
      picked = [];
      tiers = [];
      if (goodChute) { picked.push(goodChute); tiers.push('good'); }
      // Better / Best: prefer lower-priced of remaining flow/corral as better, higher as best
      var mix = [flowPick2, corralPick].filter(Boolean);
      if (mob === 'portable' && need !== 'leadup') {
        // ensure corral in mix when portable (not lead-up Q1)
        if (corralPick && mix.indexOf(corralPick) === -1) mix.push(corralPick);
      }
      mix = mix.filter(function (h, i, a) { return h && a.indexOf(h) === i && picked.indexOf(h) === -1; });
      mix.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      if (mix[0]) { picked.push(mix[0]); tiers.push('better'); }
      if (mix[1]) { picked.push(mix[1]); tiers.push('best'); }
      else if (mix.length < 2) {
        // stretch second chute as best upgrade
        var moreCh = pickGoodBetterBest(chutes3.filter(function (h) { return picked.indexOf(h) === -1; }), 1)[0];
        if (moreCh) { picked.push(moreCh); tiers.push('best'); }
      }
      // HARD: must include flow or corral
      var hasMix = picked.some(function (h) {
        return FLOW_HANDLES.indexOf(h) !== -1 || CORRAL_HANDLES.indexOf(h) !== -1;
      });
      if (!hasMix && flowPick2) {
        if (picked.length >= 3) { picked[2] = flowPick2; tiers[2] = 'best'; }
        else { picked.push(flowPick2); tiers.push('best'); }
      }
    } else {
      // setup unsure — kind from need, then G/B/B within primary family; optionally diversify
      var primary = [];
      if (need === 'loading') {
        primary = eligible(function (h) { return META[h].family === 'loading'; });
        picked = pickGoodBetterBest(primary, 2);
        tiers = ['good', 'better'].slice(0, picked.length);
        // third: chute or flow for diversity
        var extra = eligible(function (h) {
          return META[h].family === 'chute' || FLOW_HANDLES.indexOf(h) !== -1;
        });
        var ex = pickGoodBetterBest(extra, 1)[0];
        if (ex && picked.indexOf(ex) === -1) { picked.push(ex); tiers.push('best'); }
      } else if (need === 'leadup') {
        // Cattle flow / lead-up → tubs & alleys (not Grazer/Rustler primary)
        primary = eligible(function (h) { return FLOW_HANDLES.indexOf(h) !== -1; });
        picked = pickGoodBetterBest(primary, 3);
        tiers = ['good', 'better', 'best'].slice(0, picked.length);
        if (picked.length < 2) {
          eligible(function (h) { return META[h].family === 'chute'; }).slice(0, 1).forEach(function (h) {
            if (picked.indexOf(h) === -1) { picked.push(h); tiers.push('best'); }
          });
        }
      } else if (need === 'corral') {
        // Portable corral primary → Grazer/Rustler focused; Bud tub as sensible 3rd
        var corrals = eligible(function (h) { return CORRAL_HANDLES.indexOf(h) !== -1; });
        // Order by headcount preference then price ladder
        corrals.sort(function (a, b) { return scores[b] - scores[a] || priceOf(a) - priceOf(b); });
        picked = [];
        tiers = [];
        // Prefer both corrals when available
        corrals.forEach(function (h) {
          if (picked.length < 2 && picked.indexOf(h) === -1) {
            picked.push(h);
            tiers.push(picked.length === 1 ? 'good' : 'better');
          }
        });
        // If only one corral somehow, GBB pad
        if (picked.length < 2) {
          pickGoodBetterBest(corrals, 2).forEach(function (h) {
            if (picked.indexOf(h) === -1 && picked.length < 2) {
              picked.push(h);
              tiers.push(picked.length === 1 ? 'good' : 'better');
            }
          });
        }
        // 3rd: Bud tub as portable crowding helper, else stretch other corral already in, else light flow
        var third = null;
        if (scores['portable-bud-tub'] > -9999) third = 'portable-bud-tub';
        if (!third) {
          var moreFlow = eligible(function (h) {
            return h === 'portable-bud-tub' || (FLOW_HANDLES.indexOf(h) !== -1 && mob === 'portable');
          });
          third = moreFlow.sort(function (a, b) { return scores[b] - scores[a]; })[0];
        }
        if (third && picked.indexOf(third) === -1) {
          picked.push(third);
          tiers.push('best');
        } else if (picked.length < 3 && corrals.length) {
          // duplicate prevention — if only 2 corrals, already have both; leave at 2 or add chute? prefer 2–3 corral-focused
          // already have both Grazer+Rustler typically
        }
        // Ensure Grazer/Rustler assignment respects headcount: if under50, Good=Grazer when present
        if (head === 'under50' && picked.indexOf('grazer-portable-corral') !== -1) {
          picked = picked.filter(function (h) { return h !== 'grazer-portable-corral'; });
          picked.unshift('grazer-portable-corral');
          // dedupe
          picked = picked.filter(function (h, i, a) { return a.indexOf(h) === i; }).slice(0, 3);
          tiers = ['good', 'better', 'best'].slice(0, picked.length);
        }
        if ((head === 'mid' || head === 'large') && picked.indexOf('rustler-portable-corral') !== -1) {
          // put Rustler first as Good for larger
          picked = picked.filter(function (h) { return h !== 'rustler-portable-corral'; });
          picked.unshift('rustler-portable-corral');
          picked = picked.filter(function (h, i, a) { return a.indexOf(h) === i; }).slice(0, 3);
          tiers = ['good', 'better', 'best'].slice(0, picked.length);
        }
      } else {
        // chute or unsure need → prefer chutes G/B/B; if wantFlowGear swap best for flow
        primary = eligible(function (h) { return META[h].family === 'chute'; });
        picked = pickGoodBetterBest(primary, wantFlowGear ? 2 : 3);
        tiers = (wantFlowGear ? ['good', 'better'] : ['good', 'better', 'best']).slice(0, picked.length);
        if (wantFlowGear) {
          var fl = eligible(function (h) { return FLOW_HANDLES.indexOf(h) !== -1; });
          var fp = fl.sort(function (a, b) { return scores[b] - scores[a]; })[0];
          if (fp) { picked.push(fp); tiers.push('best'); }
        }
      }
    }

    // Safety fills / hard filters
    picked = picked.filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    if (chuteOnly) {
      picked = picked.filter(function (h) { return META[h].family === 'chute'; });
      if (picked.length < 3) {
        pickGoodBetterBest(eligible(function (h) { return META[h].family === 'chute'; }), 3).forEach(function (h) {
          if (picked.indexOf(h) === -1 && picked.length < 3) {
            picked.push(h);
            tiers.push(tiers.length === 0 ? 'good' : (tiers.length === 1 ? 'better' : 'best'));
          }
        });
      }
    }
    while (tiers.length < picked.length) {
      tiers.push(tiers.length === 0 ? 'good' : (tiers.length === 1 ? 'better' : 'best'));
    }
    if (picked.length < 2) {
      pickGoodBetterBest(eligible(function (h) { return META[h].family === 'chute'; }), 3).forEach(function (h) {
        if (picked.indexOf(h) === -1 && picked.length < 3) {
          picked.push(h);
          tiers.push('best');
        }
      });
    }

    ROOT._rrTiers = {};
    picked.slice(0, 3).forEach(function (h, i) {
      ROOT._rrTiers[h] = tiers[i] || (i === 0 ? 'good' : (i === 1 ? 'better' : 'best'));
    });

    return picked.slice(0, 3).map(function (p) {
      return { handle: p, score: scores[p], tier: ROOT._rrTiers[p], why: whyText(p) };
    });
  }

  function whyText(h) {
    var m = META[h];
    var bits = [];
    var need = answers.need;
    var mob = answers.mobility;
    var power = answers.power;
    var alone = answers.alone;
    var flow = answers.flow;
    var budget = answers.budget;
    var head = answers.headcount;
    var setup = answers.setup;

    if (m.family === 'chute') {
      bits.push('XL chute with palpation cage — our default working setup');
      if (power === 'manual' && m.power === 'manual') bits.push('hand-operated like you prefer');
      if (power === 'hydraulic' && m.power === 'hydraulic') bits.push('hydraulic power for the squeeze and controls');
      if (alone === 'yes' && (m.power === 'manual' || m.weight === 'light')) bits.push('manageable when you’re often working alone');
      if (mob === 'portable' && m.mobility === 'portable-friendly') bits.push('pairs well if you need to move the setup (wheel-kit friendly)');
      if (mob === 'fixed' && (h === 'big-red-xl' || h === 'cattl-ek-xl')) bits.push('built for a serious fixed yard setup');
      if (head === 'large' && m.weight === 'heavy') bits.push('sized for bigger working days');
    } else if (m.family === 'flow') {
      if (h === 'stationary-sweep-tub') bits.push('Stationary sweep tub for cattle flow / lead-up into the alley or chute');
      if (h === 'portable-bud-tub') bits.push(need === 'corral' ? 'Portable Bud Tub as a crowding helper with your portable corral' : 'Portable crowding tub for lead-up flow you can move with the setup');
      if (h === 'stationary-adjustable-alley') bits.push('Adjustable alley for cattle flow into the chute');
      if (need === 'leadup') bits.push('matches cattle flow / lead-up');
      if (mob === 'portable') bits.push('works with a move-it yard');
      if (mob === 'fixed') bits.push('suits a fixed yard');
    } else if (m.family === 'pens') {
      if (h.indexOf('grazer') !== -1) {
        bits.push(need === 'corral'
          ? 'Grazer portable corral for holding and sorting — strong fit under 50 head'
          : 'Portable corral when you’re building out a fuller pens setup');
      }
      if (h.indexOf('rustler') !== -1) {
        bits.push(need === 'corral'
          ? 'Rustler portable corral — fuller package for 50–150+ / larger sorting'
          : 'Fuller portable corral package for a complete working setup');
      }
      if (need === 'corral') bits.push('portable holding & sorting');
      if (mob === 'fixed') bits.push('portable gear you can still stage at a fixed yard');
      if (mob === 'portable') bits.push('made to move with how you work');
    } else if (m.family === 'loading') {
      if (m.mobility === 'portable') bits.push('Portable loading ramp for truck days away from a permanent dock');
      else bits.push('Stationary loading ramp for a fixed loading spot at the yard');
    }
    if (setup !== 'chute_only' && (flow === 'yes' || flow === 'unsure' || setup === 'chute_plus_flow' || setup === 'full') &&
        (h === 'stationary-sweep-tub' || h === 'portable-bud-tub' || h === 'stationary-adjustable-alley')) {
      bits.push('helps move cattle up to the chute (flow into the working area)');
    }
    if (setup === 'full' && (h.indexOf('grazer') !== -1 || h.indexOf('rustler') !== -1)) {
      bits.push('supports a fuller pens + chute working setup');
    }
    if (setup === 'chute_only' && m.family === 'chute') {
      bits.push('focused on replacing or adding the chute itself');
    }
    if (budget === 'under6k' || budget === '6to10' || budget === '10to18' || budget === '18plus') {
      bits.push('lands near the budget range you picked (equipment only — freight separate)');
    }
    if (!bits.length) bits.push('A solid fit from our public lineup for how you described the job');
    var s = bits.slice(0, 3).join(' — ') + '.';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function renderResults() {
    var picks = scoreProducts();
    grid.innerHTML = '';
    grid.className = 'rr-rh-grid' + (picks.length === 2 ? ' rr-rh-grid--2' : '');
    picks.forEach(function (pick) {
      var h = pick.handle;
      var info = catalog[h] || {};
      var title = info.title || META[h].label;
      var url = info.url || ('/products/' + h);
      var img = info.image || '';
      var priceStr = money(info.price);
      var card = document.createElement('article');
      card.className = 'rr-rh-prod';
      card.innerHTML =
        '<div class="rr-rh-prod__img">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="600" height="450">' : '') +
        '</div>' +
        '<div class="rr-rh-prod__body">' +
          (pick.tier ? '<p class="rr-rh-prod__tier">' + escapeHtml(tierLabel(pick.tier)) + '</p>' : '') +
          '<h3 class="rr-rh-prod__title">' + escapeHtml(title) + '</h3>' +
          '<p class="rr-rh-prod__why">' + escapeHtml(pick.why) + '</p>' +
          (priceStr
            ? '<p class="rr-rh-prod__price">Approx. from ' + priceStr + ' — configure / quote on product page. Freight separate.</p>'
            : '<p class="rr-rh-prod__price">Configure options and get a quote on the product page. Freight separate.</p>') +
          '<a class="rr-rh-btn rr-rh-btn--solid" href="' + url + '">View ' + escapeHtml(title) + '</a>' +
        '</div>';
      grid.appendChild(card);
    });
    ROOT._rrPicks = picks;
  }

  function tierLabel(t) {
    if (t === 'good') return 'Good — solid fit in your range';
    if (t === 'better') return 'Better — sweet spot for most ranches';
    if (t === 'best') return 'Best — step-up / stretch option';
    return '';
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function answerLabels() {
    var map = {
      need: { chute: 'Working cattle in a chute', leadup: 'Cattle flow / lead-up (tub, alley)', corral: 'Holding & sorting in a portable corral', loading: 'Loading trucks', unsure: 'Not sure' },
      headcount: { under50: 'Under 50', mid: '50–150', large: '150+', unsure: 'Not sure' },
      mobility: { fixed: 'Fixed at the yard', portable: 'Need to move it', unsure: 'Not sure' },
      alone: { yes: 'Yes', no: 'No', unsure: 'Not sure' },
      flow: { yes: 'Yes — need flow into the chute', no: 'No — mainly the chute itself', unsure: 'Not sure' },
      budget: { under6k: 'Under $6,000', '6to10': '$6,000–$10,000', '10to18': '$10,000–$18,000', '18plus': '$18,000+', unsure: 'Not sure', exploring: 'Just exploring' },
      power: { manual: 'Manual', hydraulic: 'Hydraulic', unsure: 'Not sure' },
      setup: { chute_only: 'Just the chute', chute_plus_flow: 'Chute plus flow into it', full: 'Full setup — pens, tub, alley, chute', unsure: 'Not sure' }
    };
    var lines = [];
    questions.forEach(function (q) {
      var k = q.getAttribute('data-key');
      var title = q.querySelector('h2').textContent.trim();
      var v = answers[k];
      lines.push(title + ': ' + ((map[k] && map[k][v]) || v || '—'));
    });
    return lines;
  }

  function buildMailto(opts) {
    opts = opts || {};
    var name = (document.getElementById('rr-rh-name').value || '').trim();
    var phone = (document.getElementById('rr-rh-phone').value || '').trim();
    var email = (document.getElementById('rr-rh-email').value || '').trim();
    // Ensure picks exist for the email body
    if (!ROOT._rrPicks || !ROOT._rrPicks.length) {
      ROOT._rrPicks = scoreProducts();
    }
    var picks = ROOT._rrPicks || [];
    var body = [
      'Hi R&R — ranch helper lead from https://rrlivestock.com/pages/help-me-choose',
      '',
      'Wants a real person to get back to them: YES',
      '',
      'Name: ' + (name || '(not provided)'),
      'Phone: ' + (phone || '(not provided)'),
      'Email: ' + (email || '(not provided)'),
      '',
      'Quiz answers (Q1–Q8):',
      answerLabels().map(function (l) { return '- ' + l; }).join('\n'),
      '',
      'Recommended products:',
      picks.map(function (p) {
        return '- ' + (META[p.handle].label) + ' [' + p.handle + '] https://rrlivestock.com/products/' + p.handle;
      }).join('\n'),
      '',
      'Freight quoted separately — please follow up. Thanks.'
    ].join('\n');
    var subject = opts.callback ? 'Ranch helper — wants a callback' : 'Ranch helper — quote request';
    return 'mailto:info@rrlivestock.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  // Events
  document.getElementById('rr-rh-start').addEventListener('click', function () {
    intro.classList.add('rr-rh-hidden');
    quiz.classList.remove('rr-rh-hidden');
    showStep(0);
  });

  questions.forEach(function (q) {
    q.querySelectorAll('.rr-rh-opt').forEach(function (btn) {
      btn.addEventListener('click', function () { selectOption(btn); });
    });
  });

  btnNext.addEventListener('click', function () {
    if (stepIndex < questions.length - 1) {
      showStep(stepIndex + 1);
    } else {
      showInfoStep();
    }
  });

  btnBack.addEventListener('click', function () {
    if (stepIndex > 0) showStep(stepIndex - 1);
  });

  document.getElementById('rr-rh-info-back').addEventListener('click', function () {
    hideInfoStep();
    quiz.classList.remove('rr-rh-hidden');
    showStep(questions.length - 1);
    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.getElementById('rr-rh-info-continue').addEventListener('click', handleInfoContinue);
  document.getElementById('rr-rh-info-skip').addEventListener('click', function () {
    document.getElementById('rr-rh-info-prompt').classList.remove('is-visible');
    goToResults({ sendLead: false });
  });
  document.getElementById('rr-rh-want-callback').addEventListener('change', function () {
    if (!this.checked) document.getElementById('rr-rh-info-prompt').classList.remove('is-visible');
  });

  document.getElementById('rr-rh-restart').addEventListener('click', function () {
    answers = {};
    questions.forEach(function (q) {
      q.querySelectorAll('.rr-rh-opt').forEach(function (b) { b.classList.remove('is-selected'); });
    });
    results.classList.remove('is-active');
    hideInfoStep();
    ['rr-rh-name','rr-rh-phone','rr-rh-email'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.value = '';
    });
    var cb = document.getElementById('rr-rh-want-callback');
    if (cb) cb.checked = false;
    document.getElementById('rr-rh-info-prompt').classList.remove('is-visible');
    intro.classList.remove('rr-rh-hidden');
    quiz.classList.add('rr-rh-hidden');
    window.scrollTo({ top: ROOT.offsetTop - 20, behavior: 'smooth' });
  });

  loadCatalog();
})();
